import { render } from "./SquareStencil.vue?vue&type=template&id=3deacdc7"
import script from "./SquareStencil.vue?vue&type=script&lang=js"
export * from "./SquareStencil.vue?vue&type=script&lang=js"

import "./SquareStencil.vue?vue&type=style&index=0&id=3deacdc7&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__